import { Plus } from "@icons/untitled_ui_icons";
import { Button, ButtonProps, TooltipTrigger } from "react-aria-components";
import { TooltipOnly } from "../../Tooltip/Tooltip";
import { useState } from "react";

/**
 * 
 * @deprecated use AriaButton after adding dotted border option
 * @todo Add dotted border functionality to AriaButton
 */
export default function InlineAddButton({
  size = "md",
  popoverText,
  onPress,
  buttonProps,
  isDisabled,
}: {
  size?: "sm" | "md" | "lg";
  popoverText?: string;
  onPress?: ButtonProps["onPress"];
  buttonProps?: ButtonProps;
  isDisabled?: boolean;
}) {
  if (!popoverText) {
    return <AddButton size={size} onPress={onPress} buttonProps={buttonProps} />;
  }

  return (
    <TooltipTrigger delay={0}>
      <AddButton isDisabled={isDisabled} size={size} buttonProps={buttonProps} />
      <TooltipOnly>{popoverText}</TooltipOnly>
    </TooltipTrigger>
  );
}

function AddButton({
  size = "md",
  onPress,
  isDisabled,
  buttonProps,
}: {
  size?: "sm" | "md" | "lg";
  onPress?: ButtonProps["onPress"];
  isDisabled?: ButtonProps["isDisabled"];
  buttonProps?: ButtonProps;
}) {
  const buttonSizeMap = {
    sm: 24,
    md: 32,
    lg: 40,
  };
  const plusSizeMap = {
    sm: 16,
    md: 16,
    lg: 20,
  };
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Button
      {...buttonProps}
      slot={undefined}
      onPress={onPress}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      onHoverChange={setIsHovered}
      isDisabled={isDisabled}
      style={{
        border: "dashed 1px",
        borderColor: buttonProps?.isDisabled ? "var(--gray-200)" : "var(--gray-300)",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: buttonSizeMap[size],
        width: buttonSizeMap[size],
        outline: "none",
        boxShadow: isFocused ? "0px 0px 0px 4px #98A2B324" : "none",
        backgroundColor: buttonProps?.isDisabled ? "var(--gray-50)" : isHovered ? "var(--gray-50)" : "var(--color-base-white)",
      }}
    >
      <Plus height={plusSizeMap[size]} width={plusSizeMap[size]} color={buttonProps?.isDisabled ? "var(--gray-300)" : "var(--gray-400)"} />
    </Button>
  );
}
